import Yup, { generateAddressValidation } from '../yup';

const applicant = {
  appl_det_giv_nam: Yup.string()
    .csvGivenName(true) // This allows spaces, but only in EVR applications
    .max(50, 'your first name must be less than 50 characters')
    .required('Your first name is required'),
  appl_det_fam_nam: Yup.string()
    .trim()
    .max(50, 'your first name must be less than 50 characters')
    .required('Your last name is required'),
  appl_det_dob: Yup.string()
    .csvDobOver18()
    .csvDate('Invalid date', true)
    .required('Your date of birth is required'),
  appl_det_sex: Yup.string().required('Your gender is required'),
  appl_det_sex_other: Yup.string().when('appl_det_sex', {
    is: 'U',
    then: Yup.string()
      .trim()
      .required('Your gender is required'),
  }),
  appl_det_addr_secret: Yup.string()
    .trim()
    .required(
      'Please select whether you wish to keep your address confidential'
    ),
  ...generateAddressValidation('appl_det_addr'),
  appl_det_court_heard: Yup.string().when('appl_det_addr_secret', {
    is: 'yes',
    then: Yup.string().required(
      'Please select whether you wish to have your matter heard at your local court'
    ),
  }),
  appl_det_court_in_person: Yup.string().required(
    'Please select how you prefer to appear in court'
  ),
  appl_safe_cont: Yup.array()
    .ensure()
    .min(
      1,
      'Please select at least one contact method for court communication'
    )
    .test(
      'phone-group-validation',
      'Please enter at least one phone number',
      function (value) {
        if (!value || !value.includes('phone')) {
          return true; // No phone validation needed if phone option not selected
        }
        const { appl_cont_phone_3, appl_cont_phone, appl_cont_phone_2 } = this.parent;
        return !!(appl_cont_phone_3 || appl_cont_phone || appl_cont_phone_2);
      }
    ),
  appl_cont_phone_3: Yup.string().when('appl_safe_cont', {
    is: (appl_safe_cont: string[]) =>
      appl_safe_cont && appl_safe_cont.includes('phone'),
    then: Yup.string().ausMobilePhone(),
  }),
  appl_cont_phone: Yup.string().when('appl_safe_cont', {
    is: (appl_safe_cont: string[]) =>
      appl_safe_cont && appl_safe_cont.includes('phone'),
    then: Yup.string().ausPhone(),
  }),
  appl_cont_phone_2: Yup.string().when('appl_safe_cont', {
    is: (appl_safe_cont: string[]) =>
      appl_safe_cont && appl_safe_cont.includes('phone'),
    then: Yup.string().ausPhone(),
  }),
  appl_cont_phone_vm: Yup.string().when('appl_safe_cont', {
    is: (appl_safe_cont: string[]) =>
      appl_safe_cont && appl_safe_cont.includes('phone'),
    then: Yup.string().required(
      'Please select whether it is safe to leave you a voicemail message'
    ),
  }),
  appl_cont_safe_times: Yup.array()
    .ensure()
    .when('appl_safe_cont', {
      is: (appl_safe_cont: string[]) =>
        appl_safe_cont && appl_safe_cont.includes('phone'),
      then: Yup.array()
        .ensure()
        .min(1, 'Please select a safe time for us to ring you'),
    }),
  appl_cont_email: Yup.string().when('appl_safe_cont', {
    is: (appl_safe_cont: string[]) =>
      appl_safe_cont && appl_safe_cont.includes('email'),
    then: Yup.string()
      .required('An email address is required')
      .email('Please enter a valid email address (example@domain.com)'),
  }),
};

export default applicant;
